import { Icon } from '@user-portal/wikr-components';
import React from 'react';

import Skeleton from 'components/Skeleton';

import * as S from './LoadingSkeleton.styled';

export const LoadingSkeleton = () => (
    <S.Container data-locator="meal-page-loading" data-testid="meal-page-loading">
        <S.Header>
            <S.Link to="/meals" data-locator="meal-page-back-link" data-testid="meal-page-back-link">
                <Icon name="arrowLeft" />
            </S.Link>
            <Skeleton width={200} height={40} />
        </S.Header>
        <S.RecipeContainer data-locator="meal-details-loading" data-testid="meal-details-loading">
            <Skeleton width={600} height={240} />
            <S.Content>
                <Skeleton width={300} height={24} marginTop={24} />
                <Skeleton width={240} height={20} marginTop={4} />
                <Skeleton height={74} marginTop={16} />

                <Skeleton height={144} marginTop={40} />
            </S.Content>
        </S.RecipeContainer>
    </S.Container>
);
